import { getAppGlobals } from '~/components/AppGlobals/utils';
const { VITE_ADNETWORK_PIXELJS_URL } = getAppGlobals();

const AdNetworkPixel = () => {
  return <script id="beehiiv-pixel-v1" src={VITE_ADNETWORK_PIXELJS_URL} async />;
};

export default AdNetworkPixel;
